import { createSlice } from "@reduxjs/toolkit";
import { DashboardController as Controller } from "../Controller";
const Reducer = createSlice({
  name: "Dashboard",
  initialState: Controller.InitialState,
  reducers: {
    SetDashboardData: Controller.SetDashboardData,
    ResetDashboardData: Controller.ResetDashboardData,

    // Package
    AddPackage: Controller.AddPackage,
    UpdatePackage: Controller.UpdatePackage,
    RemovePackage: Controller.RemovePackage,
    // SubPackage
    AddSubPackage: Controller.AddSubPackage,
    UpdateSubPackage: Controller.UpdateSubPackage,
    RemoveSubPackage: Controller.RemoveSubPackage,
    // Section
    AddSection: Controller.AddSection,
    UpdateSection: Controller.UpdateSection,
    RemoveSection: Controller.RemoveSection,
    // SubSection
    AddSubSection: Controller.AddSubSection,
    UpdateSubSection: Controller.UpdateSubSection,
    RemoveSubSection: Controller.RemoveSubSection,
    // SubSectionSub
    AddSubSectionSub: Controller.AddSubSectionSub,
    UpdateSubSectionSub: Controller.UpdateSubSectionSub,
    RemoveSubSectionSub: Controller.RemoveSubSectionSub,
    // Position
    AddPosition: Controller.AddPosition,
    UpdatePosition: Controller.UpdatePosition,
    RemovePosition: Controller.RemovePosition,
    // ProductType
    AddProductType: Controller.AddProductType,
    UpdateProductType: Controller.UpdateProductType,
    RemoveProductType: Controller.RemoveProductType,
    // ContactWay
    AddContactWay: Controller.AddContactWay,
    UpdateContactWay: Controller.UpdateContactWay,
    RemoveContactWay: Controller.RemoveContactWay,
    // Platform
    AddPlatform: Controller.AddPlatform,
    UpdatePlatform: Controller.UpdatePlatform,
    RemovePlatform: Controller.RemovePlatform,
    // Nitch
    AddNitch: Controller.AddNitch,
    UpdateNitch: Controller.UpdateNitch,
    RemoveNitch: Controller.RemoveNitch,
    // Interest
    AddInterest: Controller.AddInterest,
    UpdateInterest: Controller.UpdateInterest,
    RemoveInterest: Controller.RemoveInterest,
    // Branch
    AddBranch: Controller.AddBranch,
    UpdateBranch: Controller.UpdateBranch,
    RemoveBranch: Controller.RemoveBranch,
    // Team
    AddTeam: Controller.AddTeam,
    UpdateTeam: Controller.UpdateTeam,
    RemoveTeam: Controller.RemoveTeam,
    // Role
    AddRole: Controller.AddRole,
    UpdateRole: Controller.UpdateRole,
    RemoveRole: Controller.RemoveRole,
    // Classification
    AddClassification: Controller.AddClassification,
    UpdateClassification: Controller.UpdateClassification,
    RemoveClassification: Controller.RemoveClassification,
    // Status
    AddStatus: Controller.AddStatus,
    UpdateStatus: Controller.UpdateStatus,
    RemoveStatus: Controller.RemoveStatus,
    // User
    AddUser: Controller.AddUser,
    UpdateUser: Controller.UpdateUser,
    RemoveUser: Controller.RemoveUser,
    // Customer
    AddCustomer: Controller.AddCustomer,
    RemoveCustomer: Controller.RemoveCustomer,
    // Contract
    AddContract: Controller.AddContract,
    RemoveContract: Controller.RemoveContract,
    // Directory
    AddDirectory: Controller.AddDirectory,
    UpdateDirectory: Controller.UpdateDirectory,
    RestoreDirectory: Controller.RestoreDirectory,
    RemoveDirectory: Controller.RemoveDirectory,
  },
});

export default Reducer.reducer;
export const {
  SetDashboardData,
  ResetDashboardData,
  // Add
  AddPackage,
  UpdatePackage,
  RemovePackage,
  AddSubPackage,
  UpdateSubPackage,
  RemoveSubPackage,
  AddSection,
  UpdateSection,
  RemoveSection,
  AddSubSection,
  UpdateSubSection,
  RemoveSubSection,
  AddSubSectionSub,
  UpdateSubSectionSub,
  RemoveSubSectionSub,
  AddPosition,
  UpdatePosition,
  RemovePosition,
  AddProductType,
  UpdateProductType,
  RemoveProductType,
  AddContactWay,
  UpdateContactWay,
  RemoveContactWay,
  AddPlatform,
  UpdatePlatform,
  RemovePlatform,
  AddNitch,
  UpdateNitch,
  RemoveNitch,
  AddInterest,
  UpdateInterest,
  RemoveInterest,
  AddBranch,
  UpdateBranch,
  RemoveBranch,
  AddTeam,
  UpdateTeam,
  RemoveTeam,
  AddRole,
  UpdateRole,
  RemoveRole,
  AddClassification,
  UpdateClassification,
  RemoveClassification,
  AddStatus,
  UpdateStatus,
  RemoveStatus,
  AddUser,
  UpdateUser,
  RemoveUser,
  AddCustomer,
  RemoveCustomer,
  AddContract,
  RemoveContract,
  AddDirectory,
  UpdateDirectory,
  RestoreDirectory,
  RemoveDirectory,
} = Reducer.actions;
